import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const SaleBook = createAsyncThunk("Sale/SaleBook", async (data) => {
  console.log(data);

  try {
    const response = await axios.post(
      `${BaseURL}/Sale/SaleBook`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        BookIDs: data.BookIDs ? data.BookIDs : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});
export const SaleParty = createAsyncThunk("Sale/SaleParty", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/Sale/SaleParty`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        BookIDs: data.BookIDs ? data.BookIDs : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});
export const AcList = createAsyncThunk("FAS/AcList", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/FAS/AcList`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        AcGroupIDs: data.selectedIds ? data.selectedIds : "",
        ProductionGroupMstIDs: data.selectePdGroupdIds
          ? data.selectePdGroupdIds
          : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});
export const SaleItem = createAsyncThunk("Sale/SaleItem", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/Sale/SaleItem`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        BookIDs: data.selectedIds ? data.selectedIds : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const SalesPartyMonthItemQuarter = createAsyncThunk(
  "Sale/SalesPartyMonthItemQuarter",
  async (data) => {
    try {
      console.log(data);

      const response = await axios.post(
        `${BaseURL}/Sale/SalesPartyMonthItemQuarter`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesItemMonthPartyAgent = createAsyncThunk(
  "Sale/SalesItemMonthPartyAgent",
  async (data) => {
    try {
      console.log(data);

      const response = await axios.post(
        `${BaseURL}/Sale/SalesItemMonthPartyAgent`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
          ItemIDs: data.selectItemIds ? data.selectItemIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesPartyMonthItem = createAsyncThunk(
  "Sale/SalesPartyMonthItem",
  async (data) => {
    try {
      console.log(data);
      const response = await axios.post(
        `${BaseURL}/Sale/SalesPartyMonthItem`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
          ItemIDs: data.selectItemIds ? data.selectItemIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesItemMonthParty = createAsyncThunk(
  "Sale/SalesItemMonthParty",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Sale/SalesItemMonthParty`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
          ItemIDs: data.selectItemIds ? data.selectItemIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

// jay

export const Sales = createAsyncThunk("Sale/Sales", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/Sale/Sales`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
        ProductionGroupMstIDs: data.selectePdGroupdIds
          ? data.selectePdGroupdIds
          : "",
        AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
        StartDate: data.selectestartdate ? data.selectestartdate : "",
        EndDate: data.selectenddate ? data.selectenddate : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const SalesAnylysis = createAsyncThunk(
  "Sale/SalesAnylysis",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Sale/SalesAnylysis`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesAnylysisCombination = createAsyncThunk(
  "Sale/SalesAnylysisCombination",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Sale/SalesAnylysisCombination`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",

          ItemIDs: data.selectItemIds ? data.selectItemIds : "", //nahi bhej ne ye abhiiiii
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesDashboard = createAsyncThunk(
  "Sale/SalesDashboard",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Sale/SalesDashboard`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesItemMonth = createAsyncThunk(
  "Sale/SalesItemMonth",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Sale/SalesItemMonth`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
          ProductionGroupMstIDs: data.selectePdGroupdIds
            ? data.selectePdGroupdIds
            : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const SalesBtn = createAsyncThunk("Sale/SalesBtn", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/Sale/SalesBtn`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        BookIDs: data.selecteBookdIds ? data.selecteBookdIds : "",
        SubBookIDs: data.selecteSubBookdIds ? data.selecteSubBookdIds : "",
        ProductionGroupMstIDs: data.selectePdGroupdIds
          ? data.selectePdGroupdIds
          : "",
        AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
        StartDate: data.selectestartdate ? data.selectestartdate : "",
        EndDate: data.selectenddate ? data.selectenddate : "",
        Month: data.selectmonthname ? data.selectmonthname : "",
        ItemIDs: data.selectItemIds ? data.selectItemIds : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const SaleSlice = createSlice({
  name: "saleslice",
  initialState: {
    SaleBookdata: null,
    SalePartydata: null,
    SalesPartyMonthItemQuarterData: null,
    SalesPartyMonthItemData: null,
    SalesItemMonthPartyAgentData: null,
    SalesItemMonthPartyData: null,
    AcListdata: null,
    SaleItemdata: null,
    Salesdata: null,
    SalesAnylysisCombinationdata: null,
    SalesAnylysisdata: null,
    SalesDashboarddata: null,
    SalesItemMonthdata: null,
    SalesBtndata: null,

    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SaleBook.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SaleBook.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SaleBookdata = action.payload;
      })
      .addCase(SaleBook.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SaleParty.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SaleParty.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalePartydata = action.payload;
      })
      .addCase(SaleParty.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(AcList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(AcList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.AcListdata = action.payload;
      })
      .addCase(AcList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SaleItem.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SaleItem.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SaleItemdata = action.payload;
      })
      .addCase(SaleItem.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesPartyMonthItemQuarter.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesPartyMonthItemQuarter.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesPartyMonthItemQuarterData = action.payload;
      })
      .addCase(SalesPartyMonthItemQuarter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesItemMonthPartyAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesItemMonthPartyAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesItemMonthPartyAgentData = action.payload;
      })
      .addCase(SalesItemMonthPartyAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesPartyMonthItem.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesPartyMonthItem.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesPartyMonthItemData = action.payload;
      })
      .addCase(SalesPartyMonthItem.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesItemMonthParty.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesItemMonthParty.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesItemMonthPartyData = action.payload;
      })
      .addCase(SalesItemMonthParty.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    builder
      .addCase(Sales.pending, (state) => {
        state.status = "loading";
      })
      .addCase(Sales.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.Salesdata = action.payload;
      })
      .addCase(Sales.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    builder
      .addCase(SalesAnylysis.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesAnylysis.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesAnylysisdata = action.payload;
      })
      .addCase(SalesAnylysis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesAnylysisCombination.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesAnylysisCombination.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesAnylysisCombinationdata = action.payload;
      })
      .addCase(SalesAnylysisCombination.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesDashboard.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesDashboard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesDashboarddata = action.payload;
      })
      .addCase(SalesDashboard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesItemMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesItemMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesItemMonthdata = action.payload;
      })
      .addCase(SalesItemMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(SalesBtn.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalesBtn.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalesBtndata = action.payload;
      })
      .addCase(SalesBtn.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default SaleSlice.reducer;
